<div class="overlay">
  <div class="image-panel">
    <div class="image-layout">
      <div class="image-col-1">
        @if (folder.activities && folder.activities[0]) {
          <div class="relative">
            <app-doenkids-image [mediaItem]="{ uuid: folder.activities[0].media_uuid , description: '' }"></app-doenkids-image>
          </div>
        }
      </div>
      <div class="image-col-2">
        <div class="image-row">
          @if (folder.activities && folder.activities[1]) {
            <div class="relative">
              <app-doenkids-image [mediaItem]="{ uuid: folder.activities[1].media_uuid , description: '' }"></app-doenkids-image>
            </div>
          }
        </div>
        <div class="image-row">
          @if (folder.activities && folder.activities[2]) {
            <div class="relative">
              <app-doenkids-image [mediaItem]="{ uuid: folder.activities[2].media_uuid , description: '' }"></app-doenkids-image>
            </div>
          }
        </div>
      </div>
    </div>
    @if (!(isReader$ | async) && !(isShared$ | async)) {
      <button mat-mini-fab class="edit-icon" color="primary" [attr.aria-label]="'generic.edit' | translate" (click)="editFolder($event)">
        <mat-icon>edit</mat-icon>
      </button>
    }
    @if (isShared$ | async) {
      <div class="shared-icon">
        <mat-icon [matTooltip]="'generic.shared' | translate">folder_shared</mat-icon>
      </div>
    }
  </div>
  <div class="title-panel">
    <h3 class="mat-title">{{folder.name}}</h3>
    <div class="mat-h5">{{ 'pinboard.folder.activity_count' | translate: {activityCount: folder?.activities?.length || 0} }}</div>
  </div>
</div>
